export default "__VITE_ASSET__TKaGGxu5Mqw5Ve$2nKTXNg__";